export default __webpack_public_path__ + "media/images/logo/media/j_wave-6790d9f738bd048e4b0ef1147871c776.png";